/* ============================================================
   LOW KEY AUTOMOTIVE - PRO FITMENT FILTER v11 (diesel + gas)
   Inferred storefront fitment for product titles, tags, types,
   and vendors. True fitment should still come from ACES/Turn14
   data when available.
   ============================================================ */

window.LKFilter = (function() {
  var OPEN_END_YEAR = 2038;

  var PLATFORM_TERMS = {
    duramax: /\b(duramax|lb7|lly|lbz|lmm|lml|l5p|lgh|lm2|lz0|gm diesel|chevy diesel|gmc diesel|chevrolet diesel|2\.8 diesel|2\.8l diesel|3\.0 diesel|3\.0l diesel|3\.0 duramax|3\.0l duramax|6\.6 diesel|6\.6l diesel|6\.6 duramax|6\.6l duramax|silverado 1500 diesel|sierra 1500 diesel|silverado 2500|silverado 3500|sierra 2500|sierra 3500|2500hd|3500hd|2500 hd|3500 hd)\b/,
    powerstroke: /\b(powerstroke|power stroke|ford diesel|f-150 diesel|f150 diesel|super duty diesel|super duty|f250|f350|f450|f550|f 250|f 350|f 450|f 550|f-250|f-350|f-450|f-550|3\.0 powerstroke|3\.0 power stroke|3\.0l powerstroke|3\.0l power stroke|7\.3 diesel|7\.3l diesel|6\.0 diesel|6\.0l diesel|6\.4 diesel|6\.4l diesel|6\.7 diesel|6\.7l diesel)\b/,
    cummins: /\b(cummins|ecodiesel|eco diesel|ram diesel|dodge diesel|ram 1500 diesel|dodge 1500 diesel|3\.0 ecodiesel|3\.0l ecodiesel|5\.9 diesel|5\.9l diesel|6\.7 diesel|6\.7l diesel|ram 2500|ram 3500|dodge 2500|dodge 3500|ram 4500|ram 5500)\b/
  };

  /* Generic part names are not proof of vehicle fitment. Only products explicitly
     identified as universal may bypass year/engine-specific evidence. */
  var UNIVERSAL_TERMS = /\b(universal|universal fit|all diesel applications|all diesel trucks)\b/;
  var MAKE_TERMS = /\b(chevy|chevrolet|gmc|gm|dodge|ram|ford|toyota|nissan|subaru|audi|jeep|mustang|camaro|corvette|charger|challenger|tundra|tacoma|4runner)\b/;
  var GAS_ONLY_TERMS = /\b(ignition coil|coil pack|spark plug|spark plugs|throttle body spacer|camaro|corvette|challenger|charger|hemi|ecoboost|godzilla|wrx|subaru|audi|toyota|tundra|tacoma|4runner|nissan|suzuki|mustang|5\.7 hemi|6\.4 hemi|jeep 3\.6|gas only)\b/;

  function normalize(s) {
    return String(s || '').toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[‒–—―]/g, '-')
      .replace(/[()\[\]{}]/g, ' ')
      .replace(/_/g, ' ')
      .replace(/\bf[\s-]?(250|350|450|550)\b/g, 'f-$1')
      .replace(/power[\s-]?stroke/g, 'powerstroke')
      .replace(/[^a-z0-9.\-/+\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function searchableText(title, tags, type, vendor) {
    return normalize([
      title || '',
      Array.isArray(tags) ? tags.join(' ') : String(tags || ''),
      type || '',
      vendor || ''
    ].join(' '));
  }

  function yearNumber(token) {
    var raw = String(token || '').trim();
    var half = /\.5$/.test(raw) ? 0.5 : 0;
    var n = parseInt(raw.replace(/\.5$/, ''), 10);
    if (isNaN(n)) return null;
    if (n < 100) n = n < 35 ? 2000 + n : 1900 + n;
    return n + half;
  }

  function endYearNumber(startYear, token) {
    var raw = String(token || '').trim();
    var half = /\.5$/.test(raw) ? 0.5 : 0;
    var n = parseInt(raw.replace(/\.5$/, ''), 10);
    if (isNaN(n)) return null;
    if (n < 100 && startYear >= 1900) {
      var century = Math.floor(startYear / 100) * 100;
      n = century + n;
      if (n < startYear) n += 100;
    } else if (n < 100) {
      n = n < 35 ? 2000 + n : 1900 + n;
    }
    return n + half;
  }

  function parseYearRanges(text) {
    var t = normalize(text);
    var ranges = [];
    var seen = {};

    function push(startRaw, endRaw) {
      var start = yearNumber(startRaw);
      var end = endRaw === '+' ? OPEN_END_YEAR : endYearNumber(start, endRaw);
      if (start === null || end === null || end < start) return;
      if (start < 1980 || end > OPEN_END_YEAR) return;
      var key = start + '-' + end;
      if (!seen[key]) {
        seen[key] = true;
        ranges.push({ start: start, end: end });
      }
    }

    var m;
    var rangeRe = /\b((?:19|20)?\d{2}(?:\.5)?)\s*(?:-|to|through|thru)\s*((?:19|20)?\d{2}(?:\.5)?)\b/g;
    while ((m = rangeRe.exec(t))) {
      if (/^\d\.\d$/.test(m[1]) || /^\d\.\d$/.test(m[2])) continue;
      push(m[1], m[2]);
    }

    var plusRe = /\b((?:19|20)?\d{2}(?:\.5)?)\s*\+/g;
    while ((m = plusRe.exec(t))) push(m[1], '+');

    var singleYearRe = /\b(19[8-9]\d|20[0-3]\d)\b/g;
    while ((m = singleYearRe.exec(t))) push(m[1], m[1]);

    return ranges;
  }

  function selectedYearNumber(selectedYear) {
    var yr = parseInt(selectedYear, 10);
    return isNaN(yr) ? null : yr;
  }

  function yearCompatible(text, selectedYear) {
    var yr = selectedYearNumber(selectedYear);
    if (yr === null) return true;
    var ranges = parseYearRanges(text);
    if (!ranges.length) return true;
    return ranges.some(function(r) { return yr >= r.start && yr <= r.end; });
  }

  function selectedDuramaxCode(engine, year) {
    var e = normalize(engine);
    var yr = selectedYearNumber(year);
    if (/\blb7\b/.test(e)) return 'lb7';
    if (/\blly\b/.test(e)) return 'lly';
    if (/\blbz\b/.test(e)) return 'lbz';
    if (/\blmm\b/.test(e)) return 'lmm';
    if (/\blml\b/.test(e)) return 'lml';
    if (/\bl5p\b/.test(e)) return 'l5p';
    if (/\blgh\b|\b2\.8l?\b/.test(e)) return 'lgh';
    if (/\blm2\b|\blz0\b|\b3\.0l?\b/.test(e)) return 'd30';
    if (yr === null) return '';
    if (yr >= 2001 && yr <= 2004) return 'lb7';
    if (yr >= 2005 && yr <= 2005) return 'lly';
    if (yr >= 2006 && yr <= 2007) return 'lbz';
    if (yr >= 2008 && yr <= 2010) return 'lmm';
    if (yr >= 2011 && yr <= 2016) return 'lml';
    if (yr >= 2017) return 'l5p';
    return '';
  }

  function selectedPowerstrokeCode(engine, year) {
    var e = normalize(engine);
    var yr = selectedYearNumber(year);
    if (/\b7\.3\b/.test(e)) return '7.3';
    if (/\b6\.0\b/.test(e)) return '6.0';
    if (/\b6\.4\b/.test(e)) return '6.4';
    if (/\b6\.7\b/.test(e)) return '6.7';
    if (/\b3\.0l?\b/.test(e)) return '3.0';
    if (yr === null) return '';
    if (yr >= 1994 && yr <= 2003) return '7.3';
    if (yr >= 2004 && yr <= 2007) return '6.0';
    if (yr >= 2008 && yr <= 2010) return '6.4';
    if (yr >= 2011) return '6.7';
    return '';
  }

  function selectedCumminsCode(engine, year) {
    var e = normalize(engine);
    var yr = selectedYearNumber(year);
    if (/\becodiesel\b|\beco diesel\b|\b3\.0l?\b/.test(e)) return 'ecodiesel';
    if (/\b12v\b|12 valve/.test(e)) return '5.9-12v';
    if (/\b24v\b|24 valve/.test(e)) return '5.9-24v';
    if (/common rail|common-rail/.test(e) || /\b5\.9\b/.test(e)) return '5.9-cr';
    if (/\b6\.7\b/.test(e)) return '6.7';
    if (yr === null) return '';
    if (yr >= 1994 && yr <= 1998) return '5.9-12v';
    if (yr >= 1999 && yr <= 2002) return '5.9-24v';
    if (yr >= 2003 && yr <= 2007) return '5.9-cr';
    if (yr >= 2008) return '6.7';
    return '';
  }

  function vehiclePlatform(make, model, engine) {
    var m = normalize(make);
    var mdl = normalize(model);
    var e = normalize(engine);
    var vehicle = m + ' ' + mdl + ' ' + e;
    if (/\b(lb7|lly|lbz|lmm|lml|l5p|lgh|duramax|6\.6)\b/.test(e)) return 'duramax';
    if (/\becodiesel\b|\beco diesel\b/.test(e) && /\b(dodge|ram|1500)\b/.test(vehicle)) return 'cummins';
    if (/\b3\.0l?\b/.test(e) && /\b(dodge|ram)\b/.test(vehicle) && /\b1500\b/.test(vehicle)) return 'cummins';
    if (/\bcummins\b|\b5\.9\b|\b6\.7\b/.test(e) && /\b(dodge|ram|2500|3500|4500|5500)\b/.test(vehicle)) return 'cummins';
    if (/\b(powerstroke|7\.3|6\.0|6\.4|6\.7)\b/.test(e) && /\b(ford|f-250|f-350|f-450|f-550|super duty)\b/.test(vehicle)) return 'powerstroke';
    if (/\b(chevrolet|chevy|gmc)\b/.test(m) && /\b(silverado|sierra|2500|3500|hd)\b/.test(mdl)) return 'duramax';
    if (/\b(dodge|ram)\b/.test(m) && /\b(ram|2500|3500|4500|5500)\b/.test(mdl)) return 'cummins';
    if (/\bford\b/.test(m) && /\b(f-250|f-350|f-450|f-550|super duty)\b/.test(mdl)) return 'powerstroke';
    return '';
  }

  function textPlatform(text) {
    var t = normalize(text);
    if (/\b(lb7|lly|lbz|lmm|lml|l5p|lgh|duramax)\b/.test(t)) return 'duramax';
    if (/\b(chevy|chevrolet|gmc|gm)\b/.test(t) && /\b(6\.6|diesel|2500|3500|hd|silverado|sierra)\b/.test(t)) return 'duramax';
    if (/\becodiesel\b|\beco diesel\b/.test(t)) return 'cummins';
    if (/\b3\.0l?\b/.test(t) && /\b(ram|dodge)\b/.test(t)) return 'cummins';
    if (/\bcummins\b/.test(t) || (/\b(5\.9|6\.7)\b/.test(t) && /\b(ram|dodge)\b/.test(t))) return 'cummins';
    if (/\b(powerstroke|power stroke|super duty|f-250|f-350|f-450|f-550)\b/.test(t)) return 'powerstroke';
    if (/\b(7\.3|6\.0|6\.4|6\.7)l?\b/.test(t) && /\b(ford|f-250|f-350|f-450|f-550)\b/.test(t)) return 'powerstroke';
    return '';
  }

  function hasPlatformTerms(text, platform) {
    var t = normalize(text);
    if (platform === 'duramax') {
      if (/\b(chevy|chevrolet)\s*(?:\/|\s+and\s+|\s+)\s*gmc\b.*\b(2500|3500|2500hd|3500hd|hd)\b/.test(t)) return true;
      if (/\bgm\s+(trucks?|hd|2500|3500|2500hd|3500hd)\b/.test(t)) return true;
    }
    return !!(PLATFORM_TERMS[platform] && PLATFORM_TERMS[platform].test(t));
  }

  function isLikelyGasOnly(text) {
    var t = normalize(text);
    if (!GAS_ONLY_TERMS.test(t)) return false;
    if (/\bjeep\b/.test(t) && /\bdiesel\b/.test(t)) return false;
    return true;
  }

  function selectedGmBody(make, model) {
    var selected = normalize([make || '', model || ''].join(' '));
    if (/\b(gmc|sierra)\b/.test(selected)) return 'gmc';
    if (/\b(chevy|chevrolet|silverado)\b/.test(selected)) return 'chevy';
    return '';
  }

  function hasSharedGmFitment(text) {
    var t = normalize(text);
    return /\b(chevy|chevrolet)\s*(?:\/|\s+and\s+|\s+)\s*gmc\b/.test(t) ||
      /\bgmc\s*(?:\/|\s+and\s+|\s+)\s*(chevy|chevrolet)\b/.test(t) ||
      /\bsilverado\s*(?:\/|\s+and\s+|\s+)\s*sierra\b/.test(t) ||
      /\bsierra\s*(?:\/|\s+and\s+|\s+)\s*silverado\b/.test(t) ||
      /\bgm\s+(trucks?|hd|2500|3500|2500hd|3500hd)\b/.test(t);
  }

  function isGmBodySpecificPart(text) {
    var t = normalize(text);
    return /\b(headlights?|head lamps?|headlight assembly|tail lights?|taillights?|tail lamps?|fog lights?|marker lights?|cab lights?|third brake|brake light|grill|grille|bumper|hood|fender|mirror|valance|emblem|body panel|bed side)\b/.test(t);
  }

  function gmBodyMismatch(text, make, model) {
    var selectedBody = selectedGmBody(make, model);
    if (!selectedBody || !isGmBodySpecificPart(text) || hasSharedGmFitment(text)) return false;

    var t = normalize(text);
    var mentionsChevyBody = /\b(chevy|chevrolet|silverado)\b/.test(t);
    var mentionsGmcBody = /\b(gmc|sierra)\b/.test(t);

    if (selectedBody === 'gmc' && mentionsChevyBody && !mentionsGmcBody) return true;
    if (selectedBody === 'chevy' && mentionsGmcBody && !mentionsChevyBody) return true;
    return false;
  }

  function titleHardRejectsVehicle(titleText, platform, make, model, engine, year) {
    var t = normalize(titleText);
    var selectedEngine = normalize(engine);
    var selectedIsThreeLiter = /\b3\.0l?\b/.test(selectedEngine);
    var selectedIsEcoDiesel = /\becodiesel\b|\beco diesel\b/.test(selectedEngine) || (platform === 'cummins' && selectedIsThreeLiter);
    if (!t) return false;
    var selectedLiters = selectedEngine.match(/(\d\.\d)\s*l?\b/);
    var explicitLiters = Array.from(t.matchAll(/\b(?:v\s*[68]\s*[-/]?\s*|l\s*[46]\s*[-/]?\s*)?(\d\.\d)\s*l\b/g)).map(function(m) { return m[1]; });
    if (selectedLiters && explicitLiters.length && explicitLiters.indexOf(selectedLiters[1]) === -1) return true;

    if (platform === 'duramax' && /\b(ford|f-150|f-250|f-350|f-450|f-550|super duty|powerstroke|dodge|ram|cummins)\b/.test(t)) return true;
    if (platform === 'powerstroke' && /\b(chevy|chevrolet|gmc|silverado|sierra|duramax|dodge|ram|cummins)\b/.test(t)) return true;
    if (platform === 'cummins' && /\b(ford|f-150|f-250|f-350|f-450|f-550|super duty|powerstroke|chevy|chevrolet|gmc|silverado|sierra|duramax)\b/.test(t)) return true;

    if (platform === 'powerstroke') {
      if ((/\bf-150\b|\bf150\b/.test(t)) && !selectedIsThreeLiter) return true;
      if (/\bv\s*8\s*[-/]?\s*(5\.0|6\.2)\s*l?\b|\bv\s*10\b|\b5\.0l?\b|\b6\.2l?\b|\bgodzilla\b/.test(t)) return true;
    }

    if (platform === 'cummins') {
      if ((/\b1500\b/.test(t) && !selectedIsEcoDiesel) || /\bhemi\b/.test(t)) return true;
      if (/\bv\s*8\s*[-/]?\s*(5\.7|6\.4)\s*l?\b|\b5\.7l?\b|\b6\.4l?\b/.test(t)) return true;
    }

    if (platform === 'duramax') {
      if ((/\b1500\b/.test(t) && !selectedIsThreeLiter) || /\bv\s*8\s*[-/]?\s*(4\.8|5\.3|6\.0|6\.2)\s*l?\b|\b5\.3l?\b|\b6\.2l?\b/.test(t)) return true;
    }

    return false;
  }

  function productDuramaxCodes(text) {
    var t = normalize(text).replace(/[/-]/g, ' ');
    var codes = ['lb7', 'lly', 'lbz', 'lmm', 'lml', 'l5p', 'lgh'].filter(function(code) {
      return new RegExp('\\b' + code + '\\b').test(t);
    });
    if (/\blm2\b|\blz0\b|\b3\.0l? duramax\b|\b3\.0l? diesel\b/.test(t)) codes.push('d30');
    return codes;
  }

  function productPowerstrokeCodes(text) {
    var t = normalize(text);
    if (textPlatform(t) !== 'powerstroke') return [];
    var codes = ['7.3', '6.0', '6.4', '6.7'].filter(function(code) {
      return new RegExp('\\b' + code.replace('.', '\\.') + 'l?\\b').test(t);
    });
    /* "3.0" alone is too generic (e.g. "Carli Dominator 3.0 System"). Only count the
       3.0L F-150 Power Stroke when the title says 3.0L or 3.0 + powerstroke/diesel. */
    if (/\b3\.0l\b|\b3\.0\s*(?:l\s*)?(?:powerstroke|diesel|v6)\b/.test(t)) codes.unshift('3.0');
    return codes;
  }

  function productCumminsCodes(text) {
    var t = normalize(text);
    var codes = [];
    if (/\becodiesel\b|\beco diesel\b/.test(t) || ((/\b3\.0l\b|\b3\.0\s*(?:l\s*)?(?:diesel|v6)\b/.test(t)) && /\b(ram|dodge|1500)\b/.test(t))) codes.push('ecodiesel');
    if (/\b12v\b|12 valve/.test(t)) codes.push('5.9-12v');
    if (/\b24v\b|24 valve/.test(t)) codes.push('5.9-24v');
    if (/common rail|common-rail/.test(t) || (/\b5\.9\b/.test(t) && !codes.length)) codes.push('5.9-cr');
    if (/\b6\.7\b/.test(t)) codes.push('6.7');
    return codes;
  }

  function selectedCode(platform, engine, year) {
    if (platform === 'duramax') return selectedDuramaxCode(engine, year);
    if (platform === 'powerstroke') return selectedPowerstrokeCode(engine, year);
    if (platform === 'cummins') return selectedCumminsCode(engine, year);
    return '';
  }

  function productCodes(platform, text) {
    if (platform === 'duramax') return productDuramaxCodes(text);
    if (platform === 'powerstroke') return productPowerstrokeCodes(text);
    if (platform === 'cummins') return productCumminsCodes(text);
    return [];
  }

  function engineCompatible(text, platform, engine, year) {
    var t = normalize(text);
    var selected = selectedCode(platform, engine, year);
    var codes = productCodes(platform, t);
    if (codes.length && selected && codes.indexOf(selected) === -1) return false;

    if (platform === 'cummins') {
      if (selected === 'ecodiesel') {
        if (/\bcummins\b|\b5\.9\b|\b6\.7\b/.test(t)) return false;
        if (/\b2500\b|\b3500\b|\b4500\b|\b5500\b/.test(t) && !/\b1500\b/.test(t)) return false;
      } else if (/\becodiesel\b|\beco diesel\b/.test(t)) {
        return false;
      }
      if (selected === '6.7' && /\b5\.9\b/.test(t) && !/\b6\.7\b/.test(t)) return false;
      if (selected !== '6.7' && /\b6\.7\b/.test(t) && !/\b5\.9\b/.test(t)) return false;
    }

    if (platform === 'powerstroke') {
      var yr = selectedYearNumber(year);
      var ranges = parseYearRanges(t);
      if (selected === '6.7' && yr !== null && yr >= 2020 && ranges.length) {
        var fits2020 = ranges.some(function(r) { return 2020 >= r.start && 2020 <= r.end; });
        if (!fits2020) return false;
      }
    }

    return true;
  }

  function isUniversalPlatformPart(text, platform) {
    var t = normalize(text);
    if (!UNIVERSAL_TERMS.test(t)) return false;
    if (!hasPlatformTerms(t, platform)) return false;
    var p = textPlatform(t);
    if (p && p !== platform) return false;
    if (parseYearRanges(t).length) return false;
    return true;
  }

  function hasUsefulSpecificFitment(text, platform, year, engine) {
    var t = normalize(text);
    var ranges = parseYearRanges(t);
    var codes = productCodes(platform, t);
    if (ranges.length && !yearCompatible(t, year)) return false;
    if (!engineCompatible(t, platform, engine, year)) return false;
    if (codes.length) return true;
    if (ranges.length) return true;
    return false;
  }

  function hasCompatibleYearProof(text, year) {
    var yr = selectedYearNumber(year);
    if (yr === null) return false;
    return parseYearRanges(text).some(function(r) {
      return yr >= r.start && yr <= r.end;
    });
  }

  function hasSelectedGmBodyProof(text, make, model) {
    var selectedBody = selectedGmBody(make, model);
    if (!selectedBody || !isGmBodySpecificPart(text)) return true;
    if (hasSharedGmFitment(text)) return true;

    var t = normalize(text);
    if (selectedBody === 'gmc') return /\b(gmc|sierra)\b/.test(t);
    if (selectedBody === 'chevy') return /\b(chevy|chevrolet|silverado)\b/.test(t);
    return false;
  }

  /* ── GAS VEHICLES ───────────────────────────────────────────
     Gas trucks/SUVs are matched on Turn 14 fitment tags:
       fits_YEAR(-YEAR)`Make`Model`Submodel~YEAR`Make`Model`Submodel...
     Products without fits_ tags fall back to the title (model name + year range).
     Parts written for a diesel platform are never shown for a gas vehicle. */
  var GAS_MAKES = { chevrolet: ['chevrolet'], chevy: ['chevrolet'], gmc: ['gmc'], ford: ['ford'], ram: ['ram', 'dodge'], dodge: ['dodge', 'ram'], jeep: ['jeep'] };
  var DIESEL_ONLY_TITLE = /\b(duramax|powerstroke|cummins|ecodiesel|eco diesel|diesel|lb7|lly|lbz|lmm|lml|l5p|lgh|12v|24v|common rail)\b/;

  function compact(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  function isGasVehicle(make, model, engine) {
    var e = normalize(engine);
    if (/\bgas\b/.test(e)) return true;
    if (e) return false;
    return !!GAS_MAKES[normalize(make)] && !vehiclePlatform(make, model, '');
  }

  function fitsEntries(tags) {
    var list = Array.isArray(tags) ? tags : String(tags || '').split(',');
    var out = [];
    list.forEach(function(tag) {
      tag = String(tag || '').trim();
      if (tag.toLowerCase().indexOf('fits_') !== 0) return;
      tag.slice(5).split('~').forEach(function(entry) {
        var f = entry.replace(/^fits_/i, '').split('`');
        if (f.length < 3) return;
        var yr = f[0].split('-');
        var y1 = parseInt(yr[0], 10), y2 = parseInt(yr[1] || yr[0], 10);
        if (isNaN(y1) || isNaN(y2)) return;
        out.push({ y1: y1, y2: y2, make: String(f[1]).toLowerCase(), model: compact(f[2]).replace(/^ram(?=\d)/, '') });
      });
    });
    return out;
  }

  function fitsListsVehicle(tags, year, make, model) {
    var yr = selectedYearNumber(year);
    var mk = gasModelKey(model);
    if (yr === null || !mk) return false;
    var makes = GAS_MAKES[normalize(make)] || [normalize(make)];
    return fitsEntries(tags).some(function(e) {
      return yr >= e.y1 && yr <= e.y2 && makes.indexOf(e.make) !== -1 && (e.model === mk || e.model.indexOf(mk) === 0);
    });
  }

  function gasModelKey(model) {
    return compact(model).replace(/^ram(?=\d)/, '');
  }

  // Returns 'verified' | 'suggested' | ''
  function gasFitment(title, tags, year, make, model) {
    var titleText = normalize(title);
    if (DIESEL_ONLY_TITLE.test(titleText)) return '';

    var yr = selectedYearNumber(year);
    var makes = GAS_MAKES[normalize(make)] || [normalize(make)];
    var mk = gasModelKey(model);
    var entries = fitsEntries(tags);

    if (entries.length) {
      var hit = entries.some(function(e) {
        if (yr !== null && (yr < e.y1 || yr > e.y2)) return false;
        if (makes.indexOf(e.make) === -1) return false;
        return !mk || e.model === mk || e.model.indexOf(mk) === 0;
      });
      return hit ? 'verified' : '';
    }

    // No structured fitment: the title must name the model, and any year range must include the year
    var base = compact(String(model || '').replace(/\b(1500|2500|3500|4500|5500)\b.*$/, '').replace(/\bsuper duty\b/i, '')) || mk;
    var ct = compact(title);
    if (!base || ct.indexOf(base) === -1) return '';
    if (base === 'cherokee' && !/cherokee/.test(titleText.replace(/grand\s*cherokee/g, ''))) return '';
    var cls = (String(model || '').match(/\b(1500|2500|3500|4500|5500)\b/) || [])[1];
    if (cls) {
      var classes = titleText.match(/\b(1500|2500|3500|4500|5500)\b/g) || [];
      if (classes.length && classes.indexOf(cls) === -1) return '';
    }
    if (!yearCompatible(titleText, year)) return '';
    return 'suggested';
  }

  function productMatchesVehicle(title, tags, year, make, model, engine, type, vendor) {
    var titleText = searchableText(title, [], '', '');
    var text = searchableText(title, tags, type, vendor);
    var hasVehicleSelection = !!(year || make || model || engine);
    if (!hasVehicleSelection) return true;

    if (isGasVehicle(make, model, engine)) return !!gasFitment(title, tags, year, make, model);

    var platform = vehiclePlatform(make, model, engine);
    if (!platform) return false;
    if (titleHardRejectsVehicle(titleText, platform, make, model, engine, year)) return false;
    if (platform === 'duramax' && gmBodyMismatch(text, make, model)) return false;
    if (isLikelyGasOnly(text)) return false;
    if (!yearCompatible(text, year)) return false;

    var productPlatform = textPlatform(text);
    if (productPlatform && productPlatform !== platform) return false;
    if (!hasPlatformTerms(text, platform)) return false;
    if (!engineCompatible(titleText, platform, engine, year)) return false;
    if (!engineCompatible(text, platform, engine, year)) return false;

    if (hasUsefulSpecificFitment(text, platform, year, engine)) return true;
    return isUniversalPlatformPart(text, platform);
  }

  function productFitmentConfidence(title, tags, year, make, model, engine, type, vendor) {
    var hasVehicleSelection = !!(year || make || model || engine);
    if (!hasVehicleSelection) return 'none';
    if (isGasVehicle(make, model, engine)) return gasFitment(title, tags, year, make, model) || 'none';
    if (!productMatchesVehicle(title, tags, year, make, model, engine, type, vendor)) return 'none';

    var platform = vehiclePlatform(make, model, engine);
    var text = searchableText(title, tags, type, vendor);

    if (!hasCompatibleYearProof(text, year)) return 'suggested';
    if (platform === 'duramax' && !hasSelectedGmBodyProof(text, make, model)) return 'suggested';
    // Diesel part already passed the platform/engine checks above; upgrade to "verified"
    // when Turn 14's fitment also lists this exact year + make + model
    if (fitsListsVehicle(tags, year, make, model)) return 'verified';
    return 'suggested';
  }

  function productFitmentBadge(title, tags, year, make, model, engine, type, vendor) {
    var confidence = productFitmentConfidence(title, tags, year, make, model, engine, type, vendor);
    if (confidence === 'verified') {
      return {
        matches: true,
        confidence: 'verified',
        label: 'Fits Your Vehicle',
        title: 'The manufacturer lists this part for your year, make and model. Engine and trim options can still matter.',
        ariaLabel: 'Verified fit for selected vehicle. Verify VIN-specific options before ordering.'
      };
    }
    if (confidence === 'suggested') {
      return {
        matches: true,
        confidence: 'suggested',
        label: 'Suggested Fit - Verify',
        title: 'Product data matches the selected vehicle platform but needs final VIN or product-detail verification before ordering.',
        ariaLabel: 'Suggested fit for selected vehicle. Verify before ordering.'
      };
    }
    return {
      matches: false,
      confidence: 'none',
      label: '',
      title: '',
      ariaLabel: ''
    };
  }

  /*
    Internal matcher examples:
    - 2016 Chevrolet Silverado 2500HD 6.6L Duramax LML:
      pass "2011-2016 Chevy GMC Duramax LML Fuel Filter Kit"
      fail "2017-2022 Duramax L5P Intake"
    - 2021 Ford F-250 Super Duty 6.7L Power Stroke:
      pass "2020+ Ford 6.7 Powerstroke Fuel System Kit"
      fail "2011-2016 Ford 6.7 Powerstroke Intercooler Pipe"
    - 2018 Ram 2500 6.7L Cummins:
      pass "2013-2018 Ram 6.7 Cummins Lift Pump"
      fail "1998.5-2002 Dodge 5.9 24V Cummins Injector"
  */

  return {
    productMatchesVehicle: productMatchesVehicle,
    parseYearRanges: parseYearRanges,
    vehiclePlatform: vehiclePlatform,
    textPlatform: textPlatform,
    yearCompatible: yearCompatible,
    gmBodyMismatch: gmBodyMismatch,
    productFitmentConfidence: productFitmentConfidence,
    productFitmentBadge: productFitmentBadge,
    isGasVehicle: isGasVehicle,
    gasFitment: gasFitment
  };
})();

